export const systemKeys = {
  all: ['system'] as const,
  detail: (id?: number) => [...systemKeys.all, 'detail', id] as const,
};

export default systemKeys;
